import React from "react";

import { OKSectionBox } from "commonsComponents/OKSectionBox";
import { OKLink } from "commonsComponents/OKLink";
const { FormattedText, formatText } = require("core/i18n").i18n;

import "./consentsChangeBox.scss";

// @constants
import { CONTEXT_KEY } from 'constants/aggregator/aggregatorConsents.constants';

export const ConsentsChangeBox = () => {
    return (
        <OKSectionBox
            className="consents-change-section"
            title={formatText(`${CONTEXT_KEY}-boxTitle`)}
        >
            <div className="row">
                <div className="col-xs-12 content-no-padding rights-profile-section__description">
                    <FormattedText value={`${CONTEXT_KEY}-boxDescription`} />
                </div>
                <div className="col-xs-12 content-no-padding last-cell">
                    <OKLink
                        modifier="complementary"
                        to="/myProfile/consent-agregator"
                    >
                        <FormattedText value={`${CONTEXT_KEY}-profileLink`} />
                    </OKLink>
                </div>
            </div>
        </OKSectionBox>
    );
};
